import makeStyles from '@mui/styles/makeStyles';

export const useListItemTextStyles = makeStyles({
  primary: {
    fontSize: ({ isMobile }) => (isMobile ? '12px' : '14px')
  },
  secondary: {
    fontSize: '12px',
    color: 'var(--normal-gray)'
  }
});

export const useListItemIconStyles = makeStyles({
  root: {
    minWidth: ({ isMobile }) => (isMobile ? '15px' : '25px')
  }
});

export const useCheckboxStyles = makeStyles({
  colorPrimary: {
    padding: '6px',
    '&& .MuiSvgIcon-root': {
      fontSize: ({ isMobile }) => (isMobile ? '15px' : '20px')
    },
    '&&.Mui-checked': { color: ({ checkboxColor }) => checkboxColor || '' }
  }
});
